import React from "react";
import { useTranslation } from "react-i18next";

const ProgressCircle = ({ current, total }) => {
  const { t } = useTranslation();
  const percent = (current * 100) / total;
  return (
    <span
      className="counter-hold absolute v-middle left-7"
      style={{
        width: "47px",
        height: "47px",
      }}
    >
      <svg width="47" height="47" viewBox="0 0 38 38">
        <g>
          <g style={{ transform: "translate(1px, 1px)" }}>
            <path
              fill="none"
              stroke="#fff"
              strokeMiterlimit="50"
              d="M.896 17.355c0-8.864 7.185-16.049 16.049-16.049 8.863 0 16.048 7.185 16.048 16.049 0 8.863-7.185 16.049-16.048 16.049-8.864 0-16.049-7.186-16.049-16.05z"
            />
          </g>
          <g
            className="circle-over"
            style={{
              transform: "translate(1px, 1px)",
              strokeDasharray: `${percent},101`,
              transition: "all ease .3s",
            }}
          >
            <path
              fill="none"
              stroke="#fff"
              strokeWidth="3"
              strokeLinecap="round"
              strokeMiterlimit="50"
              d="M.896 17.355c0-8.864 7.185-16.049 16.049-16.049 8.863 0 16.048 7.185 16.048 16.049 0 8.863-7.185 16.049-16.048 16.049-8.864 0-16.049-7.186-16.049-16.05z"
            />
          </g>
        </g>
      </svg>
      <span
        style={{
          position: "absolute",
          top: "35%",
          left: 0,
          width: "100%",
          fontSize: "8px",
          textAlign: "center",
          color: "white",
        }}
      >
        {current} {t("of")} {total}
      </span>
    </span>
  );
};

export default ProgressCircle;
